import type { AfterViewInit, WritableSignal } from '@angular/core';
import { ChangeDetectionStrategy, Component, signal, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PalantirTextComponent } from '../../../../text/text.component';
import type { PalantirFilterValidatorMessages } from '../../../filter-modal.type';

@Component({
  selector: 'palantir-filter-modal-error-display',
  standalone: true,
  imports: [PalantirTextComponent, ReactiveFormsModule],
  templateUrl: './error-display.component.html',
  styleUrl: './error-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirFilterModalErrorDisplayComponent implements AfterViewInit {
  public readonly control = input.required<FormControl>();

  public readonly validatorsMessages = input.required<
    PalantirFilterValidatorMessages | undefined
  >();

  public errorMessagesEntries: WritableSignal<{ key: string; value: string }[]> = signal([]);

  public ngAfterViewInit(): void {
    if (!this.validatorsMessages()) {
      return;
    }

    this.control().statusChanges.subscribe(() => {
      this.updateErrorMessages();
    });
  }

  public updateErrorMessages(): void {
    const controlErrors = this.control().errors;

    if (!controlErrors) {
      this.errorMessagesEntries.set([]);
      return;
    }

    const errorMessages = Object.entries(controlErrors)
      .map(([key]) => {
        const message = this.validatorsMessages()![key];
        if (!message) {
          return null;
        }

        return { key, value: message };
      })
      .filter((message): message is { key: string; value: string } => message !== null);

    this.errorMessagesEntries.set(errorMessages);
  }
}
